import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EGuideDetailSortField,
  IGuideDetail,
  PGuideDetailFilter,
} from "src/core/guideDetail/entities";
import {
  ActionType,
  createAction,
  createAsyncAction,
  getType,
} from "typesafe-actions";

/*
 * state
 */
export interface IGuideDetailState {
  guideDetails: IGuideDetail[];
  loading: boolean;
  error: unknown;
  meta: IMeta;
  filter: PGuideDetailFilter;
  pagination: IPagination;
  sorts: ISort<EGuideDetailSortField>[];
  refreshDelay: number;
}

const INITIAL_STATE: IGuideDetailState = {
  guideDetails: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
  filter: {},
  pagination: {
    limit: 10,
    offset: 0,
  },
  sorts: [],
  refreshDelay: 5000,
};

/*
 * action types
 */
const FETCH_REQUESTED = "guideDetail/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "guideDetail/FETCH_SUCCEEDED";
const FETCH_FAILED = "guideDetail/FETCH_FAILED";
const SET_FILTER_PAGINATION_SORT = "guideDetail/SET_FILTER_PAGINATION_SORT";
const SET_REFRESH_DELAY = "guideDetail/SET_REFRESH_DELAY";
const POLLING_START_REQUESTED = "guideDetail/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "guideDetail/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  setFilterPaginationSort: createAction(SET_FILTER_PAGINATION_SORT)<{
    filter: PGuideDetailFilter;
    pagination: IPagination;
    sorts: ISort<EGuideDetailSortField>[];
  }>(),

  setRefreshDelay: createAction(SET_REFRESH_DELAY)<{
    refreshDelay: number;
  }>(),

  fetchAsync: createAsyncAction(FETCH_REQUESTED, FETCH_SUCCEEDED, FETCH_FAILED)<
    unknown,
    {
      data: IGuideDetail[];
      meta: IMeta;
    },
    unknown
  >(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IGuideDetailState, TActions> = (
  state = INITIAL_STATE,
  action
) => {
  return produce<IGuideDetailState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.setFilterPaginationSort): {
        const { payload } = action;
        draft.filter = payload.filter;
        draft.pagination = payload.pagination;
        draft.sorts = payload.sorts;
        break;
      }
      case getType(actions.setRefreshDelay): {
        const { payload } = action;
        draft.refreshDelay = payload.refreshDelay;
        break;
      }
      case getType(actions.fetchAsync.request): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchAsync.success): {
        const {
          payload: { data, meta },
        } = action;
        draft.guideDetails = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchAsync.failure): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
